import {apiEventserviceEndpoint} from '@/config/config.js';
import { createApiClientDefault } from "@/services/baseservice.js"

const baseservice = createApiClientDefault(apiEventserviceEndpoint)

export default {
    async getAll(eventId) {
        return await baseservice.get('/events/' + eventId + "/participants",
        { baseURL: apiEventserviceEndpoint })
    },
    async get(participantId) {
        return await baseservice.get('/participants/' + participantId,
        { baseURL: apiEventserviceEndpoint })
    },
    async update(participantId, participant) {
        return await baseservice.put('/participants/' + participantId, participant,
        { baseURL: apiEventserviceEndpoint })
    },
    async updateStatus(url) {
        return await baseservice.put(url,
            { baseURL: apiEventserviceEndpoint })
    },
};


